module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ack"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("Thank you, Mom and Dad, for supporting me each time I took the road less traveled, even though you lost sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("Thank you, Just in, for being the wind beneath my wings.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("Thank you, Leslie, for being there at the start and cheering me on.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500eb950","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0003_ack.vue
// module id = 63
// module chunks = 0